import axios from 'axios';

//axios.defaults.baseURL = 'http://192.168.200.13:8081/';
// axios.defaults.baseURL = 'http://iot.rnpig.com/api/v1/';
// axios.defaults.baseURL = 'http:// iot.hsfxm.cn/api/v1/';


const service = axios.create({
  timeout: 40000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=UTF-8'
  },
})
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    return res
  },
  error => {
  }
)
export default service
